// hooks/useRuleById.js
import { useState, useEffect } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

export function useRuleByID(ruleId) {
  const { user } = useAuth();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ruleId || !user?.id || !user?.accessToken || !user?.companyId) return;

    let isMounted = true;

    async function fetchRules() {
      setLoading(true);
      setError(null);

      try {
        const res = await makeApiRequest(
          "get",
          apiRoutes.getRuleByID(ruleId),
          { id: user.id, accessToken: user.accessToken },
          user.companyId
        );

        if (isMounted) {
          setRules(res?.data ?? []); // API returns array
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          console.error("[useRuleByID] fetch failed", err);
          setError(err);
          setLoading(false);
        }
      }
    }

    fetchRules();
    return () => {
      isMounted = false;
    };
  }, [ruleId, user?.id, user?.accessToken, user?.companyId]);

  return { rules, loading, error, setRules };
}
